export const TeeTimeSkeleton = () => (
  <div className="md:rounded-xl rounded-lg bg-secondary-white h-full w-[18rem] md:w-[20.5rem] flex-shrink-0 flex flex-col mr-4">
    {/* Header */}
    <div className="border-b border-stroke">
      <div className="flex justify-between py-1 px-2 md:px-3 md:p-3 items-center">
        <div className="h-4 md:h-6 w-[3.75rem] bg-gray-200 rounded-md animate-pulse" />
        <div className="h-[2.5rem] w-[5rem] bg-gray-200 rounded-md animate-pulse" />
      </div>
    </div>
    <div className="flex flex-col gap-1 md:gap-4 p-2 md:p-3 text-[0.625rem] md:text-[0.875rem] flex-1">
      <div className="flex flex-col gap-1 md:gap-4 flex-1">
        {/* Price */}
        <div className="pt-1.5 md:pt-0">
          <div className="h-4 md:h-5 w-[5rem] bg-gray-200 rounded-md animate-pulse" />
        </div>
        <div className="flex flex-col flex-1">
          {/* Holes + Price class row */}
          <div className="flex items-center gap-2 mb-3">
            <div className="h-[33px] w-[9rem] bg-gray-200 rounded-full animate-pulse" />
            <div className="h-[33px] w-[130px] bg-gray-200 rounded-full animate-pulse" />
          </div>
          {/* Players row */}
          <div className="mt-auto">
            <div className="h-[33px] w-full bg-gray-200 rounded-full animate-pulse" />
          </div>
        </div>
      </div>
      {/* Buy button row */}
      <div className="flex items-center gap-2 mt-auto">
        <div className="h-[2rem] w-full bg-gray-200 rounded-full animate-pulse" />
        <div className="h-[2rem] w-[2rem] flex-shrink-0 bg-gray-200 rounded-full animate-pulse" />
      </div>
    </div>
  </div>
);
